import { Card, type CardProps } from '@common/ui/Card';

import styles from './AdvantageCard.module.scss';

export interface AdvantageCardProps extends CardProps {
  icon: React.ReactNode;
  text: string;
}

export const AdvantageCard = ({ icon, text, ...props }: AdvantageCardProps) => {
  return (
    <Card {...props} className={styles.advantageCard}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.text}>{text}</div>
    </Card>
  );
};
